<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>PO管理</el-breadcrumb-item>
        <el-breadcrumb-item>PO计费单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="建单时间">
                <el-date-picker v-model="searchForm.createTime" type="daterange" range-separator="-" style="width: 100%"
                  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleDateChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计费类型">
                <el-select clearable v-model="searchForm.billType" placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in ticketTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域园区">
                <el-select clearable v-model="searchForm.campusName" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option
                    v-for="(item, index) in campusOptions"
                    :key="index"
                    :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否超时">
                <el-select clearable v-model="searchForm.timeOut" placeholder="请选择" style="width: 100%">
                  <el-option label="已超时" value="已超时"></el-option>
                  <el-option label="未超时" value="未超时"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="PO确认单">
                <el-input v-model="searchForm.opTicketid" placeholder="请输入PO确认单"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单单号">
                <el-input v-model="searchForm.ticket_id" placeholder="请输入工单单号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">PO计费单</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width">
            <template slot-scope="scope">
              <span v-if="column.prop === 'createTime'">{{
                scope.row[column.prop]
                  ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : '-'
              }}</span>
              <el-tag v-else-if="column.prop === 'isChange'" :type="scope.row[column.prop] === 0 ? 'info' : 'warning'"
                size="small">
                {{ scope.row[column.prop] === 0 ? '未变更' : '已变更' }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'time_out'"
                :type="scope.row[column.prop] === '已超时' ? 'danger' : 'success'" size="small">
                {{ scope.row[column.prop] || '-' }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'bill_type'" type="primary" size="small">
                {{ scope.row[column.prop] || '-' }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'feedback_status'"
                :type="scope.row[column.prop] === '已收单' ? 'success' : 'warning'" size="small">
                {{ scope.row[column.prop] || '-' }}
              </el-tag>
              <span v-else-if="column.prop === 'po_num'">
                <a :href="scope.row.feedback_status === '已收单'
                  ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.po_num}&isHistory=1`
                  : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.po_num}`
                  " target="_blank">{{ scope.row.po_num }}</a>
              </span>
              <span v-else-if="column.prop === 'svrItem'">{{
                'PO计费单-' + (scope.row.orderNo || '-')
              }}</span>
              <span v-else-if="column.prop === 'opTicketid'">
                <a :href="scope.row.feedback_status === '已收单'
                  ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}`
                  " target="_blank">{{ scope.row.opTicketid }}</a>
              </span>
              <span v-else-if="['supplierMemo', 'billMemo'].includes(column.prop)">
                <el-tooltip :content="scope.row[column.prop]" placement="top"
                  :disabled="!scope.row[column.prop] || scope.row[column.prop].length <= 20"
                  popper-class="custom-tooltip" :open-delay="200" :popper-style="{ maxWidth: '70vw' }">
                  <span>{{ scope.row[column.prop] && scope.row[column.prop].length > 20 ?
                    scope.row[column.prop].substring(0, 20) + '...' : (scope.row[column.prop] || '-') }}</span>
                </el-tooltip>
              </span>
              <span v-else-if="['faultAppendInfo', 'tpcAppendInfo'].includes(column.prop)">
                <el-link
                  v-if="scope.row[column.prop] && scope.row[column.prop] !== '{}' && isValidJson(scope.row[column.prop])"
                  type="primary" @click="showDetail(scope.row[column.prop], column.label)">
                  查看详情
                </el-link>
                <span v-else>
                  {{ scope.row[column.prop] || '{}' }}
                </span>
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="detailDialog.title" :visible.sync="detailDialog.visible" width="50%"
          :before-close="closeDetailDialog">
          <el-table :data="formatObjectToArray(detailDialog.data)" border stripe max-height="400">
            <el-table-column prop="key" label="键名" width="180"></el-table-column>
            <el-table-column prop="value" label="值">
              <template slot-scope="scope">
                <span v-if="typeof scope.row.value === 'object'">{{ JSON.stringify(scope.row.value, null, 2) }}</span>
                <span v-else style="white-space: pre-line;">{{ scope.row.value }}</span>
              </template>
            </el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDetailDialog">关闭</el-button>
          </span>
        </el-dialog>
        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getBillingList, costPoListAll } from '@/api/appManage';
import { getMachineList } from '@/api/workOrder';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getCampusList } from '@/api/operation';
export default {
  name: 'FaultList',
  data() {
    return {
      fieldKeyMap: {
        // faultAppendInfo 字段映射
        'instanceId': '上游单号',
        'dispatchTime': '业务工单派单时间',
        'timeoutReason': '超时原因',
        'timeoutDesc': '超时描述',
        'timeoutAttachments': '超时附件',
        'isManualReview': '是否人工审核',
        'reviewRemark': '审核备注',
        'repairEvidence': '维修过程举证',
        'shutdownScript': '停机脚本',
        // tpcAppendInfo 字段映射
        'timeoutEvidence': '超时举证',
        'exceptionReason': '计费异常原因',
        'handleResult': '处理结果',
        'endExceptionType': '结单异常类型'
      },
      debouncedExport: null,
      faults: [],
      searchForm: {
        createTime: '',
        ticketType: '',
        orderNo: '',
        po_num: '',
        serviceInfo: '',
        campusName: '',
        ticketLevel: '',
        ticket_id: '',
        opTicketid: '',
        billType: '',
      },
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      ticketTypeOptions: [
        { value: 0, label: '不计费' },
        { value: 1, label: '全额' },
        { value: 2, label: '七折' },
      ],
      campusNameOptions: [
        { value: 'sh-lg', label: '上海-临港' },
        { value: 'sh-sy', label: '上海-书院' },
        { value: 'hz-dg', label: '杭州-东冠' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'opTicketid',
        'svrItem',
        'po_num',
        'ticketId_waitTodo',
        'campusName',
        'num',
        'realNum',
        'createTime',
        'isChange',
        'bill_type',
        'feedback_status',
        'time_out',
        'faultAppendInfo',
        'tpcAppendInfo',
        'supplierPhoto',
        'supplierMemo',
        'billMemo',
        'billPhoto'
      ],
      defaultSelectedColumns: [
        'opTicketid',
        'svrItem',
        'po_num',
        'ticketId_waitTodo',
        'campusName',
        'num',
        'realNum',
        'createTime',
        'isChange',
        'bill_type',
        'feedback_status',
        'time_out',
        'faultAppendInfo',
        'tpcAppendInfo',
        'supplierPhoto',
        'supplierMemo',
        'billMemo',
        'billPhoto'
      ],
      columns: [
        { prop: 'opTicketid', label: 'PO计费单单号', width: 130 },
        { prop: 'svrItem', label: 'PO计费单标题', width: 180 },
        { prop: 'po_num', label: 'PO确认单', width: 130 },
        { prop: 'ticketId_waitTodo', label: '工单单号', width: 130 },
        { prop: 'campusName', label: '区域-园区' },
        { prop: 'num', label: '需求数量' },
        { prop: 'realNum', label: '处理数量' },
        { prop: 'createTime', label: 'PO计费单建单时间', width: 160 },
        { prop: 'isChange', label: '是否变更' },
        { prop: 'bill_type', label: '计费类型' },
        { prop: 'feedback_status', label: '响应状态', width: 80 },
        { prop: 'time_out', label: '是否超时' },
        { prop: 'faultAppendInfo', label: '故障补充信息' },
        { prop: 'tpcAppendInfo', label: 'TPC补充信息' },
        { prop: 'supplierPhoto', label: '供应商举证照片' },
        { prop: 'supplierMemo', label: '供应商举证信息' },
        { prop: 'billMemo', label: '服务台举证信息' },
        { prop: 'billPhoto', label: '服务台提交照片' },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
      detailDialog: {
        visible: false,
        title: '',
        data: {}
      }
    };
  },
  created() {
    // 设置默认日期范围为最近一个月
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.createTime = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.createTime);

    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    //园区获取数据接口
    async getCampusData() {  
      try {
        const params = {
          spec_sign: 0,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data; 
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    isValidJson(str) {
      if (!str) return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    },

    showDetail(data, title) {
      try {
        this.detailDialog.data = JSON.parse(data);
        this.detailDialog.title = title;
        this.detailDialog.visible = true;
      } catch (e) {
        this.$message.error('数据解析失败');
      }
    },

    closeDetailDialog() {
      this.detailDialog.visible = false;
      this.detailDialog.data = {};
      this.detailDialog.title = '';
    },

    formatObjectToArray(obj) {
      if (!obj || typeof obj !== 'object') return [];
      return Object.keys(obj).map(key => {
        let value = obj[key];
        // 优化超时描述字段，将<p>标签替换为换行符
        if (key === 'timeoutDesc' && typeof value === 'string') {
          value = value.replace(/<p>/g, '').replace(/<\/p>/g, '\n').trim();
        }
        return {
          key: this.fieldKeyMap[key] || key,
          value: value
        };
      });
    },
    handleDateChange(val) {
      if (val) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = val[1] + ' 23:59:59';
      } else {
        this.searchForm.start_time = '';
        this.searchForm.end_time = '';
      }
    },
    getMachineLists() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };
      getMachineList(params)
        .then((res) => {
          this.machineList = res.data.data.list || [];
        })
        .catch(() => {
          this.$message.error(errorMessage);
        });
    },
    fetchFaultData() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        ...Object.fromEntries(
          Object.entries(this.searchForm).filter(
            ([_, value]) => value !== '' && value !== null && value !== undefined
          )
        ),
      };

      // 处理日期范围
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        params.start_time = this.$moment(this.searchForm.createTime[0]).format('YYYY-MM-DD');
        params.end_time = this.$moment(this.searchForm.createTime[1]).format('YYYY-MM-DD');
        delete params.createTime;
        params.end_time = params.end_time + ' 23:59:59';
      }
      this.loading = true;
      getBillingList(params)
        .then((response) => {
          if (response.data) {
            this.faults = response.data.data.list || [];
            this.total = response.data.data.total || 0;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.error('请求错误:', error);
          let errorMessage = '获取数据失败';
          if (error.response && error.response.status === 422) {
            errorMessage = '请求参数格式不正确，请检查输入';
          }
          this.$message.error(errorMessage);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      this.searchForm = {
        start_time: '',
        end_time: '',
        timeOut: '',
        campusName: '',
        ticket_id: '',
        opTicketid: '',
        order_level: '',
        po_num: '',
        billType: '',
      };

      // 重置后设置默认日期范围为最近一个月


      this.currentPage = 1;
      this.fetchFaultData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        let exportData = [];
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await costPoListAll({
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
          });

          if (response.data) {
            this.loading = false;
            exportData = response.data.data.list || [];
          }
        } else {
          // 导出选中数据
          exportData = this.selectedRows;
        }

        // 转换数据格式
        const worksheetData = exportData.map((row) => {
          const rowData = {};
          this.visibleColumns.forEach((column) => {
            let value = row[column.prop];

            // 根据字段类型进行特殊处理
            switch (column.prop) {
              case 'createTime':
                value = row[column.prop]
                  ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : '-';
                break;
              case 'isChange':
                value = row[column.prop] === 0 ? '未变更' : '已变更';
                break;
              case 'time_out':
                value = row[column.prop] || '-';
                break;
              case 'bill_type':
                value = row[column.prop] || '-';
                break;
              case 'feedback_status':
                value = row[column.prop] || '-';
                break;
              case 'faultAppendInfo':
              case 'tpcAppendInfo':
                // 处理字典字段，将键名转换为中文
                if (value && value !== '{}' && this.isValidJson(value)) {
                  try {
                    const parsedData = JSON.parse(value);
                    const formattedEntries = Object.entries(parsedData).map(([key, val]) => {
                      const chineseKey = this.fieldKeyMap[key] || key;
                      // 优化超时描述字段，将<p>标签替换为换行符
                      if (key === 'timeoutDesc' && typeof val === 'string') {
                        val = val.replace(/<p>/g, '').replace(/<\/p>/g, '\n').trim();
                      }
                      return `${chineseKey}: ${val}`;
                    });
                    value = formattedEntries.join('\n');
                  } catch (e) {
                    value = value || '-';
                  }
                } else {
                  value = value || '{}';
                }
                break;
              default:
                value = value || '-';
            }

            rowData[column.label] = value;
          });
          return rowData;
        });

        // 创建工作簿和工作表
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);

        // 设置列宽
        const colWidths = {};
        this.visibleColumns.forEach((column, index) => {
          const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
          colWidths[XLSX.utils.encode_col(index)] = { wch: width };
        });
        worksheet['!cols'] = Object.values(colWidths);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'PO计费单');

        // 生成文件名
        const timestamp = this.$moment().format('YYYYMMDDHHmmss');
        const filename = `PO计费单_${timestamp}.xlsx`;

        // 导出文件
        XLSX.writeFile(workbook, filename);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    }
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: calc(100% - 10px) !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: calc(110% - 10px) !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: calc(110% - 10px) !important;
}

::v-deep .el-form-item__content {
  width: calc(110% - 10px) !important;
}

::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-tooltip__popper.custom-tooltip {
  max-width: 70vw !important;
}

::v-deep .el-tooltip__popper.custom-tooltip .el-tooltip__content {
  max-width: 70vw !important;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal !important;
}
</style>
